import { Flex, Text } from "@chakra-ui/react"

interface IProps {
  label?: string;
  children?: any;
}

export const ListHeader = ({ label, children }: IProps) => {
  return (
    <Flex wrap="wrap" width="full" borderBottom="1px solid #a0a0a0" pb={2}>
      <Text fontSize="2.2rem" color="#404244" fontWeight="700">
        {label}

        {children}
      </Text>
    </Flex>
  )
}